import t from "../i18n/I18n";
const TooltipText = {
    Profile: t('TOOLTIP_TEXTS.SETTINGS_PROFILE'),
    Application: t('TOOLTIP_TEXTS.SETTINGS_APPLICATION'),
    AssetUploadButton: t('TOOLTIP_TEXTS.ASSET_UPLOAD_BUTTON'),
    NavbarHelp: t('TOOLTIP_TEXTS.NAVBAR_HELP'),
    AssetDetailsListVersion: t('TOOLTIP_TEXTS.ASSET_VERSION'),
    AddFileLocation: t('TOOLTIP_TEXTS.ADD_FILE_LOCATION'),
    ZoomInOutSlider: t('TOOLTIP_TEXTS.ZOOM_IN_OUT_SLIDER'),
    CustomizeDataView: t('TOOLTIP_TEXTS.CUSTOMIZE_DATA_VIEW'),
    AddSpotLight: t('TOOLTIP_TEXTS.ADD_SPOTLIGHT'),
    AssetListVIew: t('TOOLTIP_TEXTS.ASSET_LIST_VIEW'),
    AssetGridVIew: t('TOOLTIP_TEXTS.ASSET_GRID_VIEW'),
    Notification: t('TOOLTIP_TEXTS.NOTIFICATION'),
    Deleted : t('TOOLTIP_TEXTS.DELETED_ASSET'),
    DynamicCollection: t('TOOLTIP_TEXTS.DYNAMIC_COLLECTION'),
    SpatialComments: t('TOOLTIP_TEXTS.SPATIAL_COMMENT'),
    FilePathPlaceholder : t('TOOLTIP_TEXTS.FILE_PATH_PLACEHOLDER'),
    UploadFromUrl : t('TOOLTIP_TEXTS.UPLOAD_FROM_URL'),
    AdditionalLockTooltip : t('TOOLTIP_TEXTS.ADDITIONAL_LOCK_TOOLTIP'),
    NewFolder : t('TOOLTIP_TEXTS.NEW_FOLDER'),
  };
  
export default TooltipText;